import type { TinyEmitter } from "@expert/event-bus";
import type { WebSocketLike } from "react-use-websocket/dist/lib/types";
import { create } from "zustand";
import type { ExpertUniversityEvents } from "./src";

export interface ExpertUniversityStore {
    audioHeader?: ArrayBuffer;
    profileId?: string | undefined;
    sessionId?: string | undefined;
    eventBus?: TinyEmitter<ExpertUniversityEvents> | undefined;
    audioElements?: HTMLAudioElement[];
    isBotPlaying?: boolean;
    /**
     * Reconnect is set to false on the first connection, and then set to true
     * when the connection is closed to pass onto reconnected websocket connections
     * in the same session
     */
    reconnect?: boolean;
    setAudioHeader: (audioHeader: ArrayBuffer | undefined) => void;
    setReconnect: (reconnect: boolean) => void;
    setIsBotPlaying: (isPlaying: boolean) => void;
    sendMessage?: (msg: ArrayBuffer) => void;
    getWebsocket?: () => WebSocketLike | null;
    setProfileId: (profileId: string | undefined) => void;
    setSessionId: (sessionId: string | undefined) => void;
    setWSFunctions: (send: (msg: ArrayBuffer) => void, getWs: () => WebSocketLike | null) => void;
    resetEvents: () => void;
    setEventBus: (eventBus: TinyEmitter | undefined) => void;
}

export const useExpertUniversityStore = create<ExpertUniversityStore>((set, _get) => ({
    setAudioHeader: (audioHeader) => set({ audioHeader }),
    setIsBotPlaying: (isPlaying) => set({ isBotPlaying: isPlaying }),
    setReconnect: (reconnect) => set({ reconnect }),
    setProfileId: (profileId) => set({ profileId }),
    setSessionId: (sessionId) => set({ sessionId }),
    setEventBus: (eventBus) => set({ eventBus }),
    audioElements: [],
    setWSFunctions: (send, getWs) => set({ sendMessage: send, getWebsocket: getWs }),
    resetEvents: () =>
        set({
            profileId: undefined,
            audioElements: [],
            isBotPlaying: false,
        }),
}));
